import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { VESISConfig } from '~/types/config'

import { FeeDistributor, FeeDistributor__factory } from './types'

export function getFeeDistributorContract(
	config: VESISConfig,
	provider: StaticJsonRpcProvider
): FeeDistributor {
	return FeeDistributor__factory.connect(
		config.feeDistributorAddress,
		provider
	)
}
